import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useAuth } from "../../context/AuthContext";
import { errorMessage } from "../../lib/api";

export function ChangePasswordPanel() {
  const { changePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("The two new passwords don't match"); return; }
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password changed — other devices have been signed out");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="max-w-md space-y-6 border border-border p-6" data-testid="change-password-panel">
      <div>
        <div className="eyebrow">Password</div>
        <p className="mt-2 text-sm text-neutral-600">Choose a new password for your cellar. Any other phones or browsers signed in will be signed out.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="cur-pw" className="eyebrow">Current password</Label>
        <Input id="cur-pw" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" className="rounded-none bg-transparent" data-testid="change-password-current-input" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="new-pw" className="eyebrow">New password</Label>
        <Input id="new-pw" type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} autoComplete="new-password" className="rounded-none bg-transparent" data-testid="change-password-new-input" />
        <p className="text-xs text-neutral-500">At least 8 characters.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="new-pw2" className="eyebrow">Confirm new password</Label>
        <Input id="new-pw2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} autoComplete="new-password" className="rounded-none bg-transparent" data-testid="change-password-confirm-input" />
      </div>
      <Button type="submit" disabled={busy} className="rounded-none hover-lift" data-testid="change-password-submit">{busy ? "One moment…" : "Change password"}</Button>
    </form>
  );
}
